<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";
import MultiSelect from "vue-multiselect";

// Custom components
import PageHeader from "@/components/page-header";
import DeviceModel from "@/components/superAdmin/IOTLock/DeviceModel.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import appConfig from "@/app.config";
import { iot_device_type } from "@/helpers/global.variable";

export default {
  page: {
    title: "Device Model",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "List Of Device Model",
      isLoading: false,
      table: {
        tableData: [],
      },
      addGatewatModel: false,
      isEdit: false,
      deviceModelId: null,
      deviceModel: null,
      deviceTypes: iot_device_type,
      filters: {
        device_type: { value: "all", text: "All" },
        status: "all",
      },
      isChangeFilterValue: false,
      isApplyFilter: false,
    };
  },
  computed: {
    deviceModelProps() {
      return {
        deviceModelId: this.deviceModelId,
        isEdit: this.isEdit,
        deviceModel: this.deviceModel,
      };
    },
  },
  components: {
    PageHeader,
    Drawer,
    DeviceModel,
    MultiSelect,
  },
  mounted() {
    this.getDeviceModels();
  },
  methods: {
    // Method is used to get deviceModel list
    async getDeviceModels(query = "") {
      this.isLoading = true;
      try {
        const response = await UserService.getDeviecModelList(query);
        if (response) {
          const deviceModelOptions = response.map((model) => {
            return { text: model.name, value: model.id };
          });
          localStorage.setItem(
            "device_model",
            btoa(
              JSON.stringify([
                { text: "All", value: "all" },
                ...deviceModelOptions,
              ])
            )
          );
          this.table.tableData = response;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to handle drawer
    addDeviceModelDrawer(isEdit) {
      if (typeof isEdit !== "boolean") {
        this.isEdit = false;
        this.deviceModelId = null;
        this.deviceModel = null;
      }
      this.addGatewatModel = !this.addGatewatModel;
    },
    // Method is use update and add new guest in guest list table
    handleSubmit({ data, isEdit }) {
      if (isEdit) {
        this.table.tableData = this.table.tableData.map((item) => {
          if (item.id == data.id) {
            item = data;
          }
          return item;
        });
      } else {
        this.table.tableData.push(data);
      }
      this.isEdit = false;
      this.deviceModelId = null;
      this.deviceModel = null;
      this.addDeviceModelDrawer();
      Middleware.notification(
        `${isEdit ? "Updated successfully !!" : "Added successfully !!"}`,
        "success"
      );
    },
    // Method is used to edit deviceModel
    editDeviceModel(deviceModel) {
      this.isEdit = true;
      this.deviceModel = deviceModel;
      this.deviceModelId = deviceModel.id;
      this.addDeviceModelDrawer(this.isEdit);
    },
    // Method is used to change status
    changeStatus(model) {
      let deviceModelData = new FormData();
      deviceModelData.append("is_active", model.is_active);
      UserService.editDeviecModelData(model.id, deviceModelData)
        .then(() => {
          Middleware.notification("Successfully changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to delete deviceModel
    deleteDeviceModel(device_model_id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteDeviecModel(device_model_id)
            .then(() => {
              this.table.tableData = this.table.tableData.filter(
                (deviceModel) => deviceModel.id !== device_model_id
              );
              Middleware.notification("Successfully Ddeleted !!", "danger");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is used to handle status based filter
    handleStatusFilter() {
      this.isChangeFilterValue = true;
    },
    // Method is used to apply filter
    applyFilter() {
      if (this.isApplyFilter) {
        this.filters = {
          device_type: { text: "All", value: "all" },
          status: "all",
        };
        this.isApplyFilter = false;
        return this.getDeviceModels("");
      }
      if (this.isChangeFilterValue) {
        this.isApplyFilter = true;
        let filter = "";
        if (this.filters.device_type.value !== "all") {
          filter += `?device_type=${this.filters.device_type.value}`;
        }
        if (this.filters.status !== "all") {
          if (filter == "") {
            filter += `?is_active=${this.filters.status}`;
          } else {
            filter += `&is_active=${this.filters.status}`;
          }
        }
        this.getDeviceModels(filter);
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      text="Add New"
      :isButton="true"
      :action="addDeviceModelDrawer"
    />
    <div class="card">
      <div class="card-body">
        <div class="row">
          <!-- Filter device model by device type -->
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-5">
            <MultiSelect
              class="mb-2"
              v-model="filters.device_type"
              :options="deviceTypes"
              :show-labels="false"
              placeholder="Select Hotel"
              track-by="value"
              label="text"
              name="deviceTypes"
              :allow-empty="false"
              @close="handleStatusFilter"
            />
          </div>
          <!-- Filter gateway by hotel -->
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-4">
            <select
              name="is_active"
              id="is_active"
              class="form-control mb-2"
              v-model="filters.status"
              placeholder="by is active"
              @change="handleStatusFilter"
            >
              <option value="all">All</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-3">
            <b-button
              class="float-end float-sm-start mb-2"
              variant="primary"
              @click="applyFilter"
              >{{ !isApplyFilter ? "Apply Filter" : "Clear Filter" }}</b-button
            >
          </div>
        </div>
        <div class="table-responsive">
          <v-table :data="table.tableData" class="table">
            <thead class="table-light" slot="head">
              <tr>
                <v-th sortKey="name">Name</v-th>
                <v-th sortKey="device_type">Device Type</v-th>
                <th>Create By</th>
                <th>Update By</th>
                <th>Last Update</th>
                <td>Status</td>
                <th>Action</th>
              </tr>
            </thead>
            <tbody
              v-if="!isLoading && table.tableData.length !== 0"
              slot-scope="{ displayData }"
              slot="body"
            >
              <tr v-for="(model, index) in displayData" :key="index">
                <td @click="editDeviceModel(model)">
                  {{ model.name !== null ? model.name : "-" }}
                </td>
                <td @click="editDeviceModel(model)">
                  {{
                    model.device_type !== null
                      ? model.device_type.replaceAll("_", " ")
                      : "-"
                  }}
                </td>
                <td @click="editDeviceModel(model)">
                  {{ model.created_by !== null ? model.created_by : "-" }}
                </td>
                <td @click="editDeviceModel(model)">
                  {{ model.updated_by !== null ? model.updated_by : "-" }}
                </td>
                <td @click="editDeviceModel(model)">
                  {{
                    global_format_date_and_time_custom(
                      model.updated_at,
                      "YYYY-MM-DD hh:mm A"
                    )
                  }}
                </td>
                <td>
                  <div class="form-check form-switch my-1" slot="is_active">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="model.is_active"
                      @change="
                        changeStatus({
                          id: model.id,
                          is_active: model.is_active,
                        })
                      "
                    />
                  </div>
                </td>
                <td>
                  <i
                    class="fas fa-pencil-alt text-success mx-1"
                    v-b-popover.hover="'Edit recored'"
                    id="edit"
                    @click="editDeviceModel(model)"
                  ></i>
                  <i
                    class="mdi mdi-trash-can text-danger fs-5 mx-1"
                    v-b-popover.hover="'View card details'"
                    @click="deleteDeviceModel(model.id)"
                  ></i>
                </td>
              </tr>
            </tbody>
            <tbody slot="body" v-else-if="isLoading">
              <tr v-for="item in 10" :key="item">
                <td class="placeholder-glow" v-for="no in 7" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody slot="body" v-else>
              <tr>
                <td colspan="9" class="text-center">
                  <img
                    src="@/assets/images/empty.svg"
                    class="img-fluid"
                    alt=""
                  />
                  <p>
                    <span class="text-secondary">No Data Found</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </v-table>
        </div>
      </div>
    </div>

    <!-- Drawer -->
    <Drawer
      @close="addDeviceModelDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="800"
    >
      <div v-if="addGatewatModel">
        <DeviceModel
          :currentProps="deviceModelProps"
          @submitted="handleSubmit"
          @cancelSubmit="addDeviceModelDrawer"
        ></DeviceModel>
      </div>
    </Drawer>
  </div>
</template>
